import { render, staticRenderFns } from "./giftTable.vue?vue&type=template&id=41bfbbe3&scoped=true&"
import script from "./giftTable.vue?vue&type=script&lang=js&"
export * from "./giftTable.vue?vue&type=script&lang=js&"
import style0 from "./giftTable.vue?vue&type=style&index=0&id=41bfbbe3&lang=stylus&scoped=true&"
import style1 from "./giftTable.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bfbbe3",
  null
  
)

export default component.exports